import React from 'react';
import { CardImg } from 'reactstrap';

const ProductListItem = ({
  item,
  SelectedProduct,
  SelectedProductID,
  EnabledSelection,
  togglePopUp,
  voucher,
}) => {
  return (
    <div
      className="col-item mb-4 col-md-12 col-lg-4"
      style={{ cursor: 'pointer' }}
      onClick={(e) =>
        SelectedProduct(
          e,
          item.productStripeId,
          item.priceStripeId,
          item.productId,
          item.pricingId
        )
      }
    >
      <div
        className="card"
        style={{
          border:
            SelectedProductID == item.productStripeId
              ? 'solid 1px var(--theme-color-1)'
              : '0px',
        }}
      >
        <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
          <div className="price-top-part">
            <h5 className="mb-0 font-weight-semibold color-theme-1 mb-4">
              {item.name}
            </h5>
            <p className="mt-2 text-default" style={{ height: '85px' }}>
              {item.description}
            </p>
            {item.imageUrl !== '' && (
              <CardImg
                top
                src={item.imageUrl ? item.imageUrl : ''}
                alt="Card image cap"
                className="img-thumbnail border-0 rounded-circle list-thumbnail"
              />
            )}
            {SelectedProductID == item.productStripeId ? (
              <i
                className="demo-icon simple-icon-check activeSubscription"
                id="nametip"
              ></i>
            ) : null}
            {/* <p>
              <img
                src={`https://bmbuiassetsprod.blob.core.windows.net/images/pricing/img_${item.priceStripeId}.png`}
                width="117px"
              />
            </p> */}
            {voucher === true ? (
              <p className="text-large mb-2 text-default">
                {item.currency}
                {item.price}
              </p>
            ) : (
              <p>
                <img
                  src={`https://bmbuiassetsprod.blob.core.windows.net/images/pricing/img_${item.priceStripeId}.png`}
                  width="117px"
                />
              </p>
            )}
          </div>
          <div className="pl-3 pr-3 pt-3 pb-0 d-flex price-feature-list flex-column flex-grow-1">
            <ul>
              {item.features.map((feature, index) => {
                return (
                  <li key={`feature_item_${index}`}>
                    <p className="mb-0">{feature.name}</p>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* <div className="text-center">
            {SelectedProductID != item.productStripeId && (<NavLink to="#" onClick={e => SelectedProduct(item.productStripeId, item.priceStripeId, item.productId, item.pricingId)} className="btn btn-link btn-empty btn-lg active">
              SUBSCRIBE
              <i className="simple-icon-arrow-right" />
            </NavLink>)}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProductListItem);
